import type { CarVersion } from '@/types/quote.types';

export interface PostalCodeResult {
  code: string;
  settlement?: string;
  municipality?: string;
  state?: string;
  idEstado?: number;
  idCiudad?: number;
  idMunicipio?: number;
}

type Row = Record<string, unknown>;

/** First truthy value among `keys` (mirrors `a || b || fallback`). */
export const firstTruthy = (row: Row, keys: string[], fallback: unknown): unknown => {
  for (const key of keys) {
    if (row[key]) return row[key];
  }
  return fallback;
};

const optionalNumber = (value: unknown): number | undefined =>
  value ? Number(value) : undefined;

export const mapPostalCodeRow = (item: unknown, postalCode: string): PostalCodeResult => {
  const row = item as Row;
  const codeKeys = ['d_codigo', 'CP', 'CodigoPostal', 'codigoPostal', 'cp', 'Key'];
  return {
    code: String(firstTruthy(row, codeKeys, postalCode)),
    settlement: String(firstTruthy(row, ['Colonia', 'Asentamiento', 'settlement'], '')),
    municipality: String(firstTruthy(row, ['Municipio', 'Delegacion', 'municipio'], '')),
    state: String(firstTruthy(row, ['Estado', 'estado'], '')),
    // IDs come from the stored procedure columns prefixed with 'c_'
    idEstado: optionalNumber(row.c_estado),
    idCiudad: optionalNumber(row.c_cve_ciudad),
    idMunicipio: optionalNumber(row.c_mnpio),
  };
};

export const mapVersionRow = (item: unknown, modelId: string): CarVersion => {
  const version = item as Row;
  const transmission = String(
    firstTruthy(version, ['Transmision', 'transmission'], '')
  ).toLowerCase();
  return {
    id: String(firstTruthy(version, ['Id', 'id'], '')),
    name: String(firstTruthy(version, ['Nombre', 'name'], '')),
    modelId,
    description: String(
      firstTruthy(version, ['Descripcion', 'description', 'Nombre', 'name'], '')
    ),
    transmission: transmission === 'automatico' ? 'Automatico' : 'Manual',
    doors: Number(firstTruthy(version, ['Puertas', 'doors'], 4)),
    occupants: Number(firstTruthy(version, ['Ocupantes', 'occupants'], 5)),
  };
};
